import template from './progressPie.html';

export const progressPieComponent = {
  name: 'progressPie',
  restrict: 'E',
  template,
  controllerAs: 'vm',
  bindings: {
    value: '<',
    progress: '<'
  },
};



// WEBPACK FOOTER //
// ./src/app/components/status/components/progressPie/progressPie.component.js